import React from 'react';
import styles from './dialog-layout-button.module.scss';

type Props = {
  children: React.ReactNode;
  buttons: React.ReactNode;
};

export const DialogLayoutButton: React.FC<Props> = ({ children, buttons }) => {
  return (
    <>
      <div className={styles.contentContainer}>{children}</div>
      <div className={styles.buttonsContainer}>{buttons}</div>
    </>
  );
};
